import React from 'react';

const rowCenter = (): React.CSSProperties => {
  return {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'row',
  };
};

export default rowCenter;
